import type { AnyDevice } from 'src/utils/deviceHelpers';
import { deviceHelpers } from 'src/utils/deviceHelpers';

export const DeviceName = (props: { device: AnyDevice }) => {
  const deviceType = deviceHelpers.getDeviceType(props.device);

  if (deviceType === 'RMPPMove') {
    return (
      <span>
        reMarkable Paper Pro <i>Move</i>
      </span>
    );
  }
  return deviceHelpers.getDeviceName(props.device);
};
